<template>
	<type-wrapper class="type-O" regular>
		<type-grid row="11" margin center>
			<type-text type="title" size="3" v-if="showData.name">{{ showData.name }}</type-text>
		</type-grid>
		<type-grid row="11" margin v-for="(items, index) in (showData.data || [])" :key="index" style="border-bottom: 1px solid #000000;">
			<!-- <type-text class="type-O-shrink-title" type="title" size="6" align="left" @click="items.isShow = !items.isShow" v-if="items.edd"> -->
			<type-text class="type-O-shrink-title" type="title" size="6" align="left" @click="toggleShow(index)" v-if="items.edd">
				<my-icon size="24px" color="#000000" style="margin-right: 6px;" :icon="items.isShow ? 'down' : 'right'"></my-icon>
				<div class="type-O-title">{{ items.edd }}</div>
			</type-text>
			<div v-show="items.isShow">
				<type-grid row="11" margin v-for="(item, i) in (items.su || [])" :key="i">
					<!-- <type-text class="type-O-shrink-title" type="title" size="9" align="left" @click="item.isShow = !item.isShow" v-if="item.ed"> -->
					<type-text class="type-O-shrink-title" type="title" size="9" align="left" @click="toggleShow(index, i)" v-if="item.ed">
						<my-icon size="20px" color="#000000" style="margin-right: 10px;" :icon="item.isShow ? 'down' : 'right'"></my-icon>
						<div class="type-O-title">{{ item.ed }}</div>
					</type-text>
					<type-text type="content" size="6" align="left" weight="bold" padding="0 0 20px 40px" v-show="item.isShow && item.tg">{{ item.tg }}</type-text>
				</type-grid>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 常见问题
	import mixin from '../mixin.js'
	export default {
		name: 'type-O',
		mixins: [ mixin ],
		methods: {
			toggleShow(index, subIndex) {
				if (subIndex === undefined) {
					const isShow = this.showData.data[index].isShow === false;
					this.$set(this.showData.data[index], 'isShow', isShow);
				} else {
					const isShow = this.showData.data[index].su[subIndex].isShow === false;
					this.$set(this.showData.data[index].su[subIndex], 'isShow', isShow);
				}
				this.$forceUpdate();
			}
		}
	}
</script>

<style scoped lang="less">
	.type-O{
		.type-O-shrink-title{
			display: flex;
			align-items: center;
			.type-O-title{
				display: inline-flex;
				width: calc(100% - 30px);
			}
		}
	}
</style>
